import { c as _c } from "react/compiler-runtime";
import { useFormContext } from 'react-hook-form';
import { Checkbox as CheckboxUi } from '@/components/ui/checkbox';
import { Label } from '@/components/ui/label';
import React from 'react';
import { Error } from '../Error';
import { Width } from '../Width';
export const Checkbox = t0 => {
  const $ = _c(26);
  const {
    name,
    defaultValue,
    errors,
    label,
    register,
    required: requiredFromProps,
    width
  } = t0;
  let t1;
  if ($[0] !== name || $[1] !== register || $[2] !== requiredFromProps) {
    t1 = register(name, {
      required: requiredFromProps
    });
    $[0] = name;
    $[1] = register;
    $[2] = requiredFromProps;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const props = t1;
  const {
    setValue
  } = useFormContext();
  let t2;
  if ($[4] !== props.name || $[5] !== setValue) {
    t2 = checked => {
      setValue(props.name, checked);
    };
    $[4] = props.name;
    $[5] = setValue;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== defaultValue || $[8] !== name || $[9] !== props || $[10] !== t2) {
    t3 = <CheckboxUi defaultChecked={defaultValue} id={name} {...props} onCheckedChange={t2} />;
    $[7] = defaultValue;
    $[8] = name;
    $[9] = props;
    $[10] = t2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== label || $[13] !== name) {
    t4 = <Label htmlFor={name}>{label}</Label>;
    $[12] = label;
    $[13] = name;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  let t5;
  if ($[15] !== t3 || $[16] !== t4) {
    t5 = <div className="flex items-center gap-2">{t3}{t4}</div>;
    $[15] = t3;
    $[16] = t4;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  let t6;
  if ($[18] !== errors || $[19] !== name || $[20] !== requiredFromProps) {
    t6 = requiredFromProps && errors[name] && <Error />;
    $[18] = errors;
    $[19] = name;
    $[20] = requiredFromProps;
    $[21] = t6;
  } else {
    t6 = $[21];
  }
  let t7;
  if ($[22] !== t5 || $[23] !== t6 || $[24] !== width) {
    t7 = <Width width={width}>{t5}{t6}</Width>;
    $[22] = t5;
    $[23] = t6;
    $[24] = width;
    $[25] = t7;
  } else {
    t7 = $[25];
  }
  return t7;
};